import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const todoApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/todo",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/todo",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/todo/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/todo/${id}`,
      method: "delete",
    }),
};
